// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuButton_wrapper__S3Vb3","hover":"MenuButton_hover__AMc2j","hoverBack":"MenuButton_hoverBack__Vjl7F","textLittle":"MenuButton_textLittle__Lx5aT"};